import {
  defineProductDimensions,
  frRcpaxePricingVersionDimension,
  frRcpaxeSelectedDimension,
} from '@orus.eu/dimensions'

import { frRcpaxeProductVersionDimension } from './fr-rcpaxe-dimensions.ts'
import { frRcpaxeQuoteDimension } from './fr-rcpaxe-quote-dimension.ts'

export * from './fr-rcpaxe-activity-dimensions.ts'
export * from './fr-rcpaxe-dimensions.ts'
export * from './fr-rcpaxe-exclusions.ts'
export * from './fr-rcpaxe-policy-item-dimensions.ts'
export * from './fr-rcpaxe-quote-dimension.ts'

export const frRcpaxeDimensionsModule = defineProductDimensions({
  product: 'fr-rcpaxe',
  family: 'fr-rcp',
  selectionDimension: frRcpaxeSelectedDimension,
  productVersionDimension: frRcpaxeProductVersionDimension,
  pricingVersionDimension: frRcpaxePricingVersionDimension,
  quoteV3Dimension: frRcpaxeQuoteDimension,
})
